// extracted by mini-css-extract-plugin
export var section = "moreStoriesSec-module--section--23vvh";
export var inner = "moreStoriesSec-module--inner--3K8G8";
export var head = "moreStoriesSec-module--head--3F4L2";
export var additionalLink = "moreStoriesSec-module--additionalLink--1Za26";
export var title = "moreStoriesSec-module--title--23vXG";